import { render, staticRenderFns } from "./forkModelOnWay.vue?vue&type=template&id=bb099dfe&scoped=true"
import script from "./forkModelOnWay.vue?vue&type=script&lang=js"
export * from "./forkModelOnWay.vue?vue&type=script&lang=js"
import style0 from "./forkModelOnWay.vue?vue&type=style&index=0&id=bb099dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb099dfe",
  null
  
)

export default component.exports